export const routePath = (type) => {
  const gamesType = type === "single" ? "Single Game" : "Group";
  return {
    TICKET_SINGLE_GROUP: {
      path: "/ticket-single-group",
    },
    BY_OPPONENT: {
      path: "/ticket-single-group/by-opponent",
      pageName: `Washington Nationals: Tickets: Nationals Ticketfinder: ${gamesType} Tickets: Select Opponent`,
      title: `Select Opponent`,
      prop14: `${gamesType} Tickets: By Opponent Click`,
    },
    BY_GIVEAWAY: {
      path: "/ticket-single-group/by-giveaway-landing",
      pageName: `Washington Nationals: Tickets: Nationals Ticketfinder: ${gamesType} Tickets: By Giveaway/Promotion`,
      title: `By Giveaway/Promotion`,
      prop14: `${gamesType} Tickets: By Giveaway/Promotion Click`,
    },
    GAMES_BY_OPPONENT: {
      path: "/ticket-single-group/games-by-opponent",
      pageName: `Washington Nationals: Tickets: Nationals Ticketfinder: ${gamesType} Tickets: Games By Opponent`,
      title: `Games By Opponent`,
    },
    GAMES_BY_GIVEAWAY: {
      path: "/ticket-single-group/by-giveaway",
      pageName: `Washington Nationals: Tickets: Nationals Ticketfinder: ${gamesType} Tickets: Games By Giveaway/Promotion`,
      title: `Games By Giveaway/Promotion`,
    },
    BY_DAY_OF_WEEK: {
      path: "/ticket-single-group/by-day-of-week-landing",
      pageName: `Washington Nationals: Tickets: Nationals Ticketfinder: ${gamesType} Tickets: By Day Of Week`,
      title: `By Day Of Week`,
      prop14: `${gamesType} Tickets: By Day Of Week Click`,
    },
    GAMES_BY_DAY_OF_WEEK: {
      path: "/ticket-single-group/by-day-of-week",
      pageName: `Washington Nationals: Tickets: Nationals Ticketfinder: ${gamesType} Tickets: Games By Day Of Week`,
      title: `Games By Day Of Week`,
    },
    BY_TIME_OF_DAY: {
      path: "/ticket-single-group/by-time-of-day-landing",
      pageName: `Washington Nationals: Tickets: Nationals Ticketfinder: ${gamesType} Tickets: By Time Of Day`,
      title: `By Time Of Day`,
      prop14: `${gamesType} Tickets: By Time Of Day Click`,
    },
    GAMES_BY_TIME_OF_DAY: {
      path: "/ticket-single-group/by-time-of-day",
      pageName: `Washington Nationals: Tickets: Nationals Ticketfinder: ${gamesType} Tickets: Games By Time Of Day`,
      title: `Games By Time Of Day`,
    },
    BY_PRICE: {
      path: "/ticket-single-group/by-price-landing",
      pageName: `Washington Nationals: Tickets: Nationals Ticketfinder: ${gamesType} Tickets: By Price`,
      title: `By Price`,
      prop14: `${gamesType} Tickets: By Price Click`,
    },
    GAMES_BY_PRICE: {
      path: "/ticket-single-group/by-price",
      pageName: `Washington Nationals: Tickets: Nationals Ticketfinder: ${gamesType} Tickets: Games By Price`,
      title: `Games By Price`,
    },
    GROUP_SELECT_YOUR_SEATS: {
      path: "/ticket-single-group/group-select-your-seats",
      // pageName: `Washington Nationals: Tickets: Nationals Ticketfinder: ${gamesType} Tickets: Group Select Your seats`,
      title: `Group Select Your seats`,
    },
    TICKET_SINGLE_GROUP_CHECKOUT: {
      path: "/ticket-single-group/ticket-single-group-checkout",
      // pageName: `Washington Nationals: Tickets: Nationals Ticketfinder: ${gamesType} Tickets: Ticket Single Group Checkout`,
      title: `Single Group Checkout`,
    },
  };
};
